import { StorefrontPlugins } from '@engyalo/storefront-types'

export const plugins = {} as StorefrontPlugins
